import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  MenuItem,
  CircularProgress,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelarTramo,
  getMotivosAnulacionTraslado
} from '../../../../../actions/traslados';
import snackbarUtils from '../../../../../utils/snackbarUtils';
import FormikSelect from '../../../../commons/formik/formikSelect';
import FormikTextField from '../../../../commons/formik/formikTextField';
import { StyledTrasladosDialog } from '../../../../styled/traslados';

const CancelarTramoDialog = ({ open, onClose, data, onRefresh }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const motivosAnulacion = useSelector((state) => state.traslados.motivosAnulacion);

  useEffect(() => {
    if (!open || !data) return;
    const idArt = Number(data.idArt) > 0 ? Number(data.idArt) : null;
    dispatch(getMotivosAnulacionTraslado(idArt));
  }, [open, dispatch, data]);

  if (!data) return null;

  const handleSubmit = (values) => {
    setLoading(true);
    const idArt = Number(data?.idArt) > 0 ? Number(data.idArt) : null;
    dispatch(cancelarTramo(data.idTramo, parseInt(values.idMotivo), values.observaciones, idArt))
      .then(() => {
        snackbarUtils.success("Tramo cancelado correctamente.");
        onRefresh();
        onClose();
      })
      .catch(() => {
        snackbarUtils.error("Ocurrió un error al cancelar el tramo.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <StyledTrasladosDialog.Header bgcolor="#d94040">
        Cancelar Tramo {data.nroTramoUnico || data.idTramo}
        <StyledTrasladosDialog.CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </StyledTrasladosDialog.CloseButton>
      </StyledTrasladosDialog.Header>
      <Formik
        initialValues={{
          idMotivo: '',
          observaciones: ''
        }}
        validationSchema={Yup.object().shape({
          idMotivo: Yup.string().required('El motivo es requerido'),
          observaciones: Yup.string().required('Las observaciones son requeridas')
        })}
        onSubmit={handleSubmit}
      >
        {({ submitForm }) => (
          <Form>
            <DialogContent sx={{ mt: 2 }}>
              <Alert severity="info" sx={{ mb: 3 }}>
                El tramo pasará a Cancelado. Los demás tramos no se verán afectados.
              </Alert>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikSelect name="idMotivo" label="Motivo *" fullWidth loading={motivosAnulacion?.isFetching}>
                    <MenuItem value="">Seleccionar motivo...</MenuItem>
                    {motivosAnulacion?.data?.map((m) => (
                      <MenuItem key={m.idMotivo} value={m.idMotivo}>{m.descripcion}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField name="observaciones" label="Observaciones *" fullWidth multiline rows={3} />
                </Grid>
              </Grid>
            </DialogContent>
            <StyledTrasladosDialog.Actions>
              <Button onClick={onClose} color="inherit" disabled={loading}>Volver</Button>
              <StyledTrasladosDialog.DangerButton onClick={submitForm} variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Cancelar Tramo"}
              </StyledTrasladosDialog.DangerButton>
            </StyledTrasladosDialog.Actions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CancelarTramoDialog;
